// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1___6097a39491cdccebc37","cls2":"BulkFollowListModal-cls2__e79fc2ad904403e9aeb5 BulkFollowListModal-cls1___6097a39491cdccebc37"};